// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_cn-a";
export var fulfillmentFormRail = "_cn-9";
export var headerTitleRow = "_cn-c";
export var orderDetailsWrapper = "_cn-7";
export var orderLinkTrigger = "_cn-2";
export var paymentInformationGrid = "_cn-h";
export var paymentSummaryColumn = "_cn-i";
export var shipmentContainer = "_cn-b";
export var shipmentDetailsMainPane = "_cn-8";
export var shipmentNavigationCard = "_cn-5";
export var shipmentNavigationRail = "_cn-3";
export var shipmentNavigationRailHeader = "_cn-4";
export var shipmentSummaryFact = "_cn-e";
export var shipmentSummaryGrid = "_cn-d";
export var shipmentSummaryMetadataRow = "_cn-f";
export var shipmentSummaryTags = "_cn-g";
export var shipmentWorkspace = "_cn-0";
export var shipmentWorkspaceContent = "_cn-6";
export var shipmentWorkspaceHeader = "_cn-1";